import { useState } from "react";
import { TextField } from "@material-ui/core";
import MaskedField from "components/UI/Fields/MaskedField";
import useValidations from "hooks/useValidations";
import { ContractRowMovementStore } from "store";
import { lang } from "i18nLang";

interface IProps {
  classes: any;
  onChangeData: (data: any) => void;
  onBlurInput: (field: string, value: any, isValid: boolean) => void;
}

const AdditiveRowForm = ({ classes, onChangeData, onBlurInput }: IProps) => {
  const [data, setData] = useState({
    code: "",
    description: "",
    quantity: "",
    unit: "",
    unitCost: "",
  });

  const { validated, validateFields } = useValidations({
    code: {
      required: true,
      custom: function (value) {
        return ContractRowMovementStore.verifyNewCode(value);
      },
    },
    description: "required",
    quantity: { required: true, greaterThan: { valueToCompare: 0 } },
    unit: "required",
    unitCost: { required: true, greaterThan: { valueToCompare: 0 } },
  });

  const handleChangeInput = (ev) => {
    const { name, value } = ev.target;
    const newData = { ...data };
    newData[name] = value;
    setData(newData);
    onChangeData(newData);
  };

  const handleBlurInput = (ev) => {
    const { name, value } = ev.target;
    const valid = validateFields({ [name]: value });
    onBlurInput(name, value, valid);
  };

  const handleBlurMaskedInput = (ev, value) => {
    const { name } = ev.target;
    const valid = validateFields({ [name]: value });
    onBlurInput(name, value, valid);
  };

  return (
    <form onSubmit={(ev) => ev.preventDefault()}>
      <TextField
        name="code"
        label={lang("fields.newCode")}
        className={classes.input}
        color="secondary"
        value={data.code}
        onChange={handleChangeInput}
        onBlur={handleBlurInput}
        error={!validated.code.valid}
        helperText={validated.code.text}
        fullWidth
      />
      <TextField
        name="description"
        label={lang("fields.description")}
        className={classes.input}
        color="secondary"
        value={data.description}
        onChange={handleChangeInput}
        onBlur={handleBlurInput}
        error={!validated.description.valid}
        helperText={validated.description.text}
        margin="normal"
        fullWidth
      />
      <MaskedField
        name="quantity"
        label={lang("fields.quantity")}
        className={classes.input}
        color="secondary"
        value={data.quantity}
        onChange={handleChangeInput}
        onBlur={handleBlurMaskedInput}
        onKeyDown={(ev) => ev.stopPropagation()}
        error={!validated.quantity.valid}
        helperText={validated.quantity.text}
        margin="normal"
        fullWidth
      />
      <TextField
        name="unit"
        label={lang("fields.unit")}
        className={classes.input}
        color="secondary"
        value={data.unit}
        onChange={handleChangeInput}
        onBlur={handleBlurInput}
        error={!validated.unit.valid}
        helperText={validated.unit.text}
        margin="normal"
        fullWidth
      />
      <MaskedField
        name="unitCost"
        label={lang("fields.unitCostWithCurrency")}
        className={classes.input}
        color="secondary"
        decimalScale={5}
        fixedDecimalScale={true}
        value={data.unitCost}
        onChange={handleChangeInput}
        onBlur={handleBlurMaskedInput}
        onKeyDown={(ev) => ev.stopPropagation()}
        error={!validated.unitCost.valid}
        helperText={validated.unitCost.text}
        margin="normal"
        fullWidth
      />
    </form>
  );
};

export default AdditiveRowForm;
